<template>
  <div :key="option.id">
    <label
      class="rounded-tl-md rounded-tr-md relative flex border p-4 focus:outline-none"
      :class="{ 
        'opacity-50': disabled,
        'cursor-pointer': !disabled,
        'cursor-not-allowed': disabled
      }"
    >
      <input 
        type="radio" 
        :id="`option_${option.id}`" 
        @change="handleChange"
        :name="`answer_${data?.id || 'unknown'}`" 
        :value="option.id" 
        :checked="isChecked"
        :disabled="disabled"
        class="mt-0.5 h-4 w-4 shrink-0 text-indigo-600 border-gray-300 focus:ring-indigo-600"
        :class="{ 'cursor-pointer': !disabled, 'cursor-not-allowed': disabled }"
        :aria-labelledby="`option-${option.id}-label`" 
        :aria-describedby="`option-${option.id}-description`"
      />
      <span class="mx-3">
        <div>
          <div  class="flex items-start">
            <div  class="flex">
              <img v-if="iconFile" :src="iconFile" class="max-w-32 max-h-32 w-6 mr-2" :alt="showMultiLingualText(option.answer, null, false, $i18n.locale)"/>
            </div>
            <div :id="`option-${option.id}-description`"  class="flex-1">
              {{ showMultiLingualText(option.answer, null, false, $i18n.locale) }}
            </div>
          </div>
        
        </div>
      </span>
    </label>
  </div>
</template>

<script>
import { showMultiLingualText } from '../../utils/languageUtils.js'

export default {
  name: 'FormRadioInputOption',
  props: {
    option: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMultiLingualText,
      iconFile: null
    }
  },
  computed: {
    isChecked() {
      if (!this.value) return false
      
      // Convert both to strings for comparison to handle different types
      const optionId = this.option.id?.toString()
      const selectedValue = this.value?.toString()
      
      return optionId === selectedValue
    }
  },
  mounted() {
    this.loadIcon()
    console.log('FormRadioInputOption mounted:', {
      optionId: this.option.id,
      disabled: this.disabled,
      isChecked: this.isChecked,
      value: this.value,
      dataExists: !!this.data,
      dataId: this.data?.id
    })
  },
  watch: {
    option: {
      handler() {
        this.loadIcon()
      },
      deep: true
    },
    disabled: {
      handler(newValue, oldValue) {
        console.log('FormRadioInputOption disabled changed:', {
          optionId: this.option.id,
          oldValue,
          newValue
        })
      },
      immediate: true
    },
    isChecked: {
      handler(newValue, oldValue) {
        console.log('FormRadioInputOption isChecked changed:', {
          optionId: this.option.id,
          oldValue,
          newValue,
          disabled: this.disabled
        })
      },
      immediate: true
    }
  },
  methods: {
    loadIcon() {
      if (this.option.advanced?.icon) {
        this.iconFile = this.option.advanced.icon.preview_url
      } else {
        this.iconFile = null
      }
    },
    
    handleChange(event) {
      console.log('FormRadioInputOption: handleChange called')
      console.log('FormRadioInputOption: Event:', event)
      console.log('FormRadioInputOption: Event target:', event.target)
      console.log('FormRadioInputOption: Event target value:', event.target?.value)
      console.log('FormRadioInputOption: Disabled state:', this.disabled)
      
      // Don't allow changes when disabled
      if (this.disabled) {
        console.log('FormRadioInputOption: Change blocked - component is disabled')
        event.preventDefault()
        return
      }
      
      // Create a synthetic event object that matches the expected format
      const syntheticEvent = {
        target: {
          name: `answer_${this.data?.id || 'unknown'}`,
          value: event.target.value
        }
      }
      
      console.log('FormRadioInputOption: Emitting change event with synthetic event:', syntheticEvent)
      this.$emit('change', syntheticEvent)
    }
  }
}
</script> 